// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._1KCFNEs9x{display:flex;align-items:center;padding:16px 20px;flex-shrink:0}@media (max-width: 767px){html[data-supports-mobile=true] ._1KCFNEs9x{padding:12px 16px}}a._1KCFNEs9x:hover{background-color:var(--ui-subtle-hover)}._6243BTtax{justify-content:center}._3SFAOITex{}._4ZqrXyG2x{}._1hEgaXIdx{}._27OopyByx{padding:24px 32px}@media (min-width: 1300px){._27OopyByx{padding:24px 32px}}@media (min-width: 1500px){._27OopyByx{padding:24px 32px}}._27OopyByx._6TMCkknFx{padding-left:20px;padding-right:20px}@media (max-width: 767px){html[data-supports-mobile=true] ._27OopyByx{padding:16px}}._3WuJVPJCx{padding:16px 20px}@media (min-width: 1300px){._3WuJVPJCx{padding:24px 32px}}@media (min-width: 1500px){._3WuJVPJCx{padding:24px 32px}}@media (max-width: 767px){html[data-supports-mobile=true] ._3WuJVPJCx{padding:12px 16px}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"footer-area": "_1KCFNEs9x",
	"footerArea": "_1KCFNEs9x",
	"centered": "_6243BTtax",
	"align-right": "_3SFAOITex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex-end"] + "",
	"alignRight": "_3SFAOITex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex-end"] + "",
	"unanchor": "_4ZqrXyG2x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unanchor"] + "",
	"divided-footer": "_1hEgaXIdx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["top-divider-inset"] + "",
	"dividedFooter": "_1hEgaXIdx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["top-divider-inset"] + "",
	"padding-panel": "_27OopyByx",
	"paddingPanel": "_27OopyByx",
	"in-secondary": "_6TMCkknFx",
	"inSecondary": "_6TMCkknFx",
	"padding-modal": "_3WuJVPJCx",
	"paddingModal": "_3WuJVPJCx"
};
module.exports = exports;
